// Contact Service - OOP Business Logic
import { ApiClient } from './ApiClient';
import { IContact, ICreateContactRequest } from '../interfaces/IContact';

export class ContactService {
  constructor(private apiClient: ApiClient) {}

  async createContact(data: ICreateContactRequest): Promise<IContact> {
    try {
      const created = await this.apiClient.post<IContact>('/contacts', data);
      return created;
    } catch (error) {
      console.error('Error creating contact:', error);
      throw error;
    }
  }

  async getAllContacts(): Promise<IContact[]> {
    try {
      const data = await this.apiClient.get<IContact[]>('/contacts');
      return data || [];
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  }

  async getContactById(id: string): Promise<IContact> {
    try {
      const data = await this.apiClient.get<IContact>(`/contacts/${id}`);
      return data;
    } catch (error) {
      console.error('Error fetching contact:', error);
      throw error;
    }
  }

  async getContactsByDam(damId: string): Promise<IContact[]> {
    try {
      const data = await this.apiClient.get<IContact[]>(`/contacts?damId=${damId}`);
      return data || [];
    } catch (error) {
      console.error('Error fetching contacts by dam:', error);
      throw error;
    }
  }

  async getContactsByGroup(groupId: string): Promise<IContact[]> {
    try {
      const data = await this.apiClient.get<IContact[]>(`/contacts?groupId=${groupId}`);
      return data || [];
    } catch (error) {
      console.error('Error fetching contacts by group:', error);
      throw error;
    }
  }

  async updateContact(id: string, data: Partial<IContact>): Promise<IContact> {
    try {
      const updated = await this.apiClient.put<IContact>(`/contacts/${id}`, data);
      return updated;
    } catch (error) {
      console.error('Error updating contact:', error);
      throw error;
    }
  }

  async deleteContact(id: string): Promise<void> {
    try {
      await this.apiClient.delete(`/contacts/${id}`);
    } catch (error) {
      console.error('Error deleting contact:', error);
      throw error;
    }
  }
}

export default ContactService;
